import React, { Component } from 'react';

import OrganogramBreadcrumb from "../container/breadcrumb/OrganogramBreadcrumb";

// organogram data
const organogram_data = {
    title: "Our Organogram",
    or_img: require("../../assets/images/orga.jpg"),
}

class Organogram extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <React.Fragment>
                <OrganogramBreadcrumb />
                <section className="organogram-area short-section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="section-title section-title-padding text-center">
                                    <h2>{organogram_data.title}</h2>
                                    <img className="organogram-img" className="mt-5" src={organogram_data.or_img} alt={organogram_data.or_img_alt} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        )
    }
}
export default Organogram